/* tslint:disable */
/* eslint-disable */
/**
 * Assisted Webservices
 * Enables agents to provide real-time support to customers. For example, agents are able to find a customer account or cart, bind anonymous carts to customer accounts, and provide different customer lists relative to different business applications.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Currency
 * @export
 * @interface Currency
 */
export interface Currency {
    /**
     * Code of the currency in iso format
     * @type {string}
     * @memberof Currency
     */
    isocode?: string;
    /**
     * Name of the currency
     * @type {string}
     * @memberof Currency
     */
    name?: string;
    /**
     * Boolean flag whether currency is active
     * @type {boolean}
     * @memberof Currency
     */
    active?: boolean;
    /**
     * Symbol of the currency
     * @type {string}
     * @memberof Currency
     */
    symbol?: string;
}

/**
 * Check if a given object implements the Currency interface.
 */
export function instanceOfCurrency(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CurrencyFromJSON(json: any): Currency {
    return CurrencyFromJSONTyped(json, false);
}

export function CurrencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Currency {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isocode': !exists(json, 'isocode') ? undefined : json['isocode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
    };
}

export function CurrencyToJSON(value?: Currency | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isocode': value.isocode,
        'name': value.name,
        'active': value.active,
        'symbol': value.symbol,
    };
}

